import { List, Dialog, Modal, Collapse, Toast, Tabs } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Card, Col, Row } from "react-bootstrap";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import {
  groupByMultiple,
  lowerCase,
  momentDate,
  queryParam,
  upperCase,
  useQuery,
  yearByBatch,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { PieChart } from "@mui/x-charts/PieChart";

const StaffAttendance = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("teaching");
  let searchParams = queryParam(useQuery());

  const data1 = [
    {
      id: 0,
      value: 10,
      labels: "Present",
      color: "#38b638",
      fontColor: "white",
    },
    {
      id: 1,
      value: 15,
      labels: "Absent",
      color: "#ff5050",
      fontColor: "white",
    },
  ];
  return (
    <>
      <Header backAction={true} title={<>Staff Attendance </>} />

      <div className="page-content-wrapper">
        <div className="container py-3">
          <Tabs
            className="bg-white"
            activeKey={activeTab}
            onChange={(k) => setActiveTab(k)}
          >
            <Tabs.Tab title="Teaching" key="teaching" />
            <Tabs.Tab title="Non Teaching" key="nonteaching" />
            <Tabs.Tab title="Security" key="security" />
          </Tabs>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "25%",
              marginTop: "5%",
            }}
          >
            <PieChart
              colors={["red", "blue", "green"]}
              series={[
                {
                  data: data1,
                },
              ]}
              width={500}
              height={200}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
            }}
          >
            {data1.map((item) => (
              <div
                key={item.id}
                style={{ textAlign: "center", padding: "10px" }}
              >
                <span
                  style={{
                    backgroundColor: item.color,
                    padding: "5px",
                    color: item.fontColor,
                  }}
                >
                  {item.labels} ({item.value})
                </span>
              </div>
            ))}
          </div>
          <hr></hr>

          <Card>
            <Card.Header className="card-header-bg text-uppercase fw-bold">
              Last Month Salary
            </Card.Header>
            <Card.Body className="p-0 mt-1">
              <table class="table table-sm ">
                {" "}
                <tr>
                  <td style={{ textAlign: "right" }}>Gross Pay:</td>
                  <td style={{ fontWeight: "bold" }}>1200</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "right" }}>Deduction:</td>
                  <td style={{ fontWeight: "bold" }}>1000</td>
                </tr>
                <tr>
                  <tr>
                    <td colSpan={2}></td>
                  </tr>
                </tr>
                <tr>
                  <td style={{ textAlign: "right" }}>NetPay</td>
                  <td style={{ fontWeight: "bold" }}>52222</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "right" }}>Interim. Allow</td>
                  <td style={{ fontWeight: "bold" }}>10000(+)</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "right" }}>Add. Allow</td>
                  <td style={{ fontWeight: "bold" }}>20000</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "right" }}>Arr. Salary</td>
                  <td style={{ fontWeight: "bold" }}></td>
                </tr>
                <tr>
                  <td colSpan={2}></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "right" }}>Total Earnings</td>
                  <td style={{ fontWeight: "bold" }}></td>
                </tr>
              </table>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};
export default StaffAttendance;
